/**
 * WHAT: Collects Core Web Vitals metrics (CLS, FID, FCP, LCP, TTFB) and passes them to a callback.
 * WHY:  Enables optional performance monitoring of the DAMA frontend so that slow page loads
 *       or layout shifts can be detected and addressed before they impact admin productivity.
 * @param {Function} onPerfEntry - Callback receiving each web-vital metric entry
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
